<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading">A S<span class="smallcaps">ERIES OF </span>O<span class="smallcaps">VERALL </span>P<span class="smallcaps">ERSPECTIVES</span></h1>
<p class="firstparagraph">Contrary to assumptions sometimes made in the social sciences, there is no such thing as a straightforward synchronic cross section, springing unproblematically into view the moment one’s argument requires it. A single snapshot, outside time, without a degree of chronological depth, would be lacking in life and therefore in usefulness. If I present a series of perspectives, as I intend to, from about 1450, 1500, 1550, 1600, and 1650, it is not with the idea that on each occasion I shall be able to give a precise picture of the “situation” immediately discernible at these precise dates. Rather it is to assume a convenient set of vantage points from which to look both forward and backward, according to the disposition of time, the landscapes, and the realities before our eyes.</p>
<p class="basic-paragraph">How can one gauge or comprehend life in progress without enlisting the passage of time as an accomplice?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// outofitaly_00003.vue?312695d8